var React = require("react");
var ChallengeCardStatusIcon = require('./challenge_card_status_icon');

var ChallengeCardStatusList = React.createClass({
  PropTypes: {
    status: React.PropTypes.array,
    challenge: React.PropTypes.object,
    retrieveChallengeStatusDescription : React.PropTypes.func.isRequired,
    challengeStatusDescription : React.PropTypes.object.isRequired,
    rewriteLook: React.PropTypes.bool
  },
  render: function() {
    return (
      <ul className='challenge-card__status-list'>
        { this.buildIcons() }
      </ul>
    );
  },
  buildIcons: function() {
    return (
      this.props.challenge.status.map(this.getIcon, this)
    )
  },
  getIcon: function(status, i) {
    return (
      <li className={status + '-icon'} key={i}>
        <ChallengeCardStatusIcon
          status={status}
          challengeId={this.props.challenge.id}
          retrieveChallengeStatusDescription={this.props.retrieveChallengeStatusDescription}
          challengeStatusDescription={this.props.challengeStatusDescription}
          rewriteLook={this.props.rewriteLook} />
      </li>
    )
  }
});
module.exports = ChallengeCardStatusList;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_status_list.jsx